import React from "react";

export const withSuspense = (WrappedComponent: React.ComponentType) => (
  <React.Suspense fallback={<></>}>
    <WrappedComponent />
  </React.Suspense>
);
